import { OTPInput, OTPInputContext } from 'input-otp';
import { useContext, type ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/** InputOTP de shadcn/ui: 6 casillas para el código de verificación. */
export function InputOTP({
  className,
  containerClassName,
  ...props
}: ComponentProps<typeof OTPInput>) {
  return (
    <OTPInput
      containerClassName={cn(
        'flex items-center justify-center gap-2 has-[:disabled]:opacity-60',
        containerClassName,
      )}
      className={cn('disabled:cursor-not-allowed', className)}
      {...props}
    />
  );
}

export function InputOTPSlot({ index, className }: { index: number; className?: string }) {
  const ctx = useContext(OTPInputContext);
  const slot = ctx.slots[index];
  return (
    <div
      data-slot
      data-active={slot?.isActive ? 'true' : undefined}
      className={cn(
        'relative grid h-14 w-11 place-items-center rounded-[12px] border text-2xl font-extrabold tabular transition-all sm:h-16 sm:w-12',
        'border-[var(--borde-vidrio-fuerte)] bg-[var(--input-fondo)] text-texto',
        'data-[active=true]:border-[var(--color-cian-texto)] data-[active=true]:shadow-[var(--shadow-brillo-cian)]',
        className,
      )}
    >
      {slot?.char}
      {slot?.hasFakeCaret ? (
        <span className="pointer-events-none absolute inset-0 grid place-items-center">
          <span className="h-7 w-px animate-pulse bg-[var(--color-texto)]" />
        </span>
      ) : null}
    </div>
  );
}
